<template>
  <div style="background-color: #fff">
    <van-nav-bar
      safe-area-inset-top
      left-arrow
      @click-left="onClickLeft"
      title="收货信息"
      fixed
    />
    <div class="box-content">
      <div class="div-conter">
        <van-overlay :show="isLoading">
          <div class="over-style">
            <van-loading color="#1989fa" />
          </div>
        </van-overlay>
        <van-form ref="shippingForm" validate-first @failed="validationFailed" @submit="validationPassed(giftSettings)">
          <van-field
            v-model="shipmentReceiver"
            name="shipmentReceiver"
            placeholder="请输入收货姓名"
            label="收货姓名"
            :rules="[{ required: true }]"
          />
          <van-field
            v-model="contactNumber"
            name="contactNumber"
            type="tel"
            placeholder="请输入联系方式"
            label="联系方式"
            :rules="[{ required: true }]"
          />
          <van-field
            v-model="shipmentAddress"
            name="shipmentAddress"
            placeholder="请输入收货地址"
            label="收货地址"
            :rules="[{ required: true }]"
          />
        </van-form>
      </div>
    </div>
    <div class="submitBtn">
      <div class="submitBtn-d1">
        <van-button :disabled="!formIsValid" round block type="info" @click="submit">提交</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import useStore from "../../store/index"; //storeId就是导出的那个值
import { Toast } from 'vant';
import Api from '../../api/api';
import { Dialog } from 'vant';
import { logout } from '../../common/common';

const store = useStore();

export default {
  data() {
    return {
      shipmentAddressDefined: false, // this is based on the existence of the property 'shipmentId' returned in the /user/info call when component is mounted.
      shipmentId: null,
      userId: '',
      shipmentReceiver: '',
      contactNumber: '',
      shipmentAddress: '',
      isLoading: false,
      // Redemption configuration from backend
      giftSettings: null,
      itemToBeReedeemed: store.itemToBeRedeemed,
    };
  },
  computed: {
    formIsValid() {
      if (this.shipmentReceiver && this.contactNumber && this.shipmentAddress) {
        return (this.shipmentReceiver.trim().length > 0 &&
                this.contactNumber.trim().length > 0 &&
                this.shipmentAddress.trim().length > 0);
      } else {
        return false;
      }
    }
  },
  methods: {
    updateShipmentInfo(shipmentId, receiverName, contact, address) {
      if (typeof shipmentId === 'undefined' || shipmentId === null || !receiverName || !contact || !address) {
        return Toast.fail('发生意外错误, 无法继续！');
      }
      const shipmentObj = {
        receiverName,
        contact,
        address,
      };

      return Api.updateShipment(shipmentId, shipmentObj);
    },
    createShipmentInfo(receiverName, contact, address) {
      if (!receiverName || !contact || !address) {
        return Toast.fail('发生意外错误, 无法继续！');
      }
      const shipmentObj = {
        receiverName,
        contact,
        address,
      };

      return Api.createShipment(shipmentObj);
    },
    validationPassed(giftSettings) {
      Dialog.confirm({
        message: giftSettings.submissionPrompt,
        cancelButtonText: '返回',
      }).then(() => {
        // POST/PATCH shipment address first, if successful, create gift order...
        let actionPromise;
        if (this.shipmentAddressDefined) {
          console.log('this.shipmentAddressDefined', this.shipmentAddressDefined);
          actionPromise = this.updateShipmentInfo(this.shipmentId, this.shipmentReceiver, this.contactNumber, this.shipmentAddress);
        } else {
          console.log('this.shipmentAddressDefined', this.shipmentAddressDefined);
          actionPromise = this.createShipmentInfo(this.shipmentReceiver, this.contactNumber, this.shipmentAddress);
        }

        this.isLoading = true;
        return actionPromise
          .then(shipmentResults => {
            let shipmentId = shipmentResults.data.result.shipmentId; // double check this, may not be correct
            const order = {
              userId: this.userId,
              giftId: this.itemToBeReedeemed.giftId,
              amount: 1,
              shipmentId,
            };
            return Api.createGiftOrder(order);
          })
          .then(() => {
            this.$router.replace({
              path: "/app-h5-cn/page/success",
              query: {
                  headline:'2'
              }
            });
          })
          .catch(e => {
            Toast.fail(e.message ?? e);
          })
          .finally(() => {
            this.isLoading = false;
          })
      }).catch(() => {
        // dialog cancel, no action needed...
      })
    },  
    submit() {
      console.log('Submit-form');
      this.$refs.shippingForm.submit();
    },
    validationFailed(e) {
      console.log(e)
    },
    onClickLeft() {
      this.$router.back();
    },
  },
  // lifecycle hooks
  mounted() {
    this.userId = localStorage.getItem("userId");
    if (!this.itemToBeReedeemed) {
      Toast.fail('发生意外错误, 无法继续！');
      this.$router.back();
    }
    if (!this.userId || this.userId.length === 0) {
      return logout();
    }
    this.isLoading = true;
    Promise.all([
      Api.userInfo({}),
      Api.giftSettings({})
    ]).then(([userInfo, giftSettings]) => {
      if (userInfo && giftSettings && userInfo.data.success && giftSettings.data.success) {
        if (giftSettings.data.result) {
          this.giftSettings = giftSettings.data.result;
        }
        if (userInfo.data.result) {
          console.log(userInfo.data.result)
          if (typeof userInfo.data.result.shipmentId !== 'undefined' && userInfo.data.result.shipmentId !== null) {
            this.shipmentAddressDefined = true;
            this.shipmentId = userInfo.data.result.shipmentId;
            this.shipmentReceiver = userInfo.data.result.receiverName ? userInfo.data.result.receiverName : null;
            this.contactNumber = userInfo.data.result.contact ? userInfo.data.result.contact : null;
            this.shipmentAddress = userInfo.data.result.address ? userInfo.data.result.address : null;
          } else {
            this.shipmentAddressDefined = false;
          }
        }
      } else {
        let messages = [];
        if (!giftSettings.data.success) {
          messages.push(giftSettings.data.msg ? giftSettings.data.msg : '查询配置信息失败');
        }
        if (!userInfo.data.success) {
          messages.push(userInfo.data.msg ? giftSettings.data.msg : '查询用户信息失败');
        }
        Toast.fail(messages.join(', '));
      }
    }).catch(err => {
      Toast.fail(err.message ?? err);
    })
    .finally(() => {
      this.isLoading = false;
    });
  },
};
</script>

<style lang="scss" scoped>
#app {
  background-color: black;
}
body {
  background-color: #fff;
}
.box-content {
  margin-top: 2.9rem;
  width: 100%;
  height: 80vh;
  background-color: #fff;
  .div-conter {
    width: 92%;
    margin-left: 4%;
  }
}
/deep/ .van-nav-bar__title {
  color: black !important;
  font-size: 1rem;
  font-weight: 600;
}
/deep/ .van-nav-bar .van-icon {
  color: black;
}
/deep/ .van-nav-bar__text {
  font-size: 14px;
  color: #333333;
}
.submitBtn {
  width: 100vw;
  height: 4.6rem;
  position: fixed;
  background-color: white;
  bottom: 0px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .submitBtn-d1 {
    // background-color: red;
    width: 40%;
    /deep/ .van-button--info {
      background-color: (0,133,190);
      border: solid 1px white;
      width: 100%;
    }
  }
}
.over-style {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
